import { backendRequest } from "../utils/backend";
import { FETCH_ALL_ITEMS } from "../config";

export const getBrands = () => {
    return backendRequest.get(`/brand?page=1&size=${FETCH_ALL_ITEMS}`)
};

export const createBrand = (brand) => {
    return backendRequest.post(`/brand`, { "name": brand })
};